import gql from 'graphql-tag';

/**
 * School-wide assessment-type listing for the Assessment Types manager.
 * Richer than GET_ASSESSMENT_TYPES (adds subject + term names) so the manager
 * can show each record's scope without extra round-trips.
 */
export const GET_SCHOOL_ASSESSMENT_TYPES = gql`
  query GetSchoolAssessmentTypes(
    $academic_calendar_id: ID
    $subject_id: ID
    $is_ca: Boolean
    $is_exam: Boolean
    $include_reusable: Boolean
  ) {
    schoolAssessmentTypes(
      academic_calendar_id: $academic_calendar_id
      subject_id: $subject_id
      is_ca: $is_ca
      is_exam: $is_exam
      include_reusable: $include_reusable
    ) {
      id
      name
      description
      max_score
      is_ca
      is_exam
      sequence
      subject_id
      academic_calendar_id
      subject {
        id
        name
      }
      academicCalendar {
        id
        session {
          name
        }
        termStructure {
          name
        }
      }
    }
  }
`;
